<template>
  <div class="animated fadeIn">
    <b-modal
      ref="modal-advanced-contact"
      size="xl"
      scrollable
      centered
      button-size="sm"
    >
      <template #modal-title>
        <i class="fas fa-user"></i> ADICIONAR CONTATOS AVANÇADOS
      </template>

      <div class="pl-3 pr-3">
        <!-- nome | documento | num. id -->
        <div class="form-group row">
          <div class="col-md-6">
            <label>
              <small
                class="text-danger"
                v-if="form.nomeAssociado.required"
                >*</small
              >
              Nome do Associado:
            </label>
            <div class="input-group">
              <b-form-input
                type="text"
                :placeholder="'Digite o Nome do Associado'"
                v-model="form.nomeAssociado.value"
                :size="form.nomeAssociado.maxlength"
                :required="form.nomeAssociado.required"
                :state="form.nomeAssociado.state"
              ></b-form-input>
            </div>
          </div>
          <div class="col-md-3">
            <label>
              <small
                class="text-danger"
                v-if="form.document.required"
                >*</small
              >
              Documento:
            </label>
            <div class="input-group">
              <b-form-input
                type="text"
                :placeholder="'Digite o CPF ou CNPJ'"
                v-model="form.document.value"
                :size="form.document.maxlength"
                :required="form.document.required"
                :state="form.document.state"
                v-mask="['###.###.###-##', '##.###.###/####-##']"
              ></b-form-input>
            </div>
          </div>
          <div class="col-md-3">
            <label>
              <small
                class="text-danger"
                v-if="form.numId.required"
                >*</small
              >
              {{ $t('associates.number') }}
            </label>
            <div class="input-group">
              <b-form-input
                type="text"
                :placeholder="`Digite o ${$t('associates.number')}`"
                v-model="form.numId.value"
                :size="form.numId.maxlength"
                :required="form.numId.required"
                :state="form.numId.state"
              ></b-form-input>
            </div>
          </div>
        </div>

        <!-- pa | regional | cluster -->
        <div class="form-group row">
          <div class="col-md-4">
            <label>
              <small
                class="text-danger"
                v-if="form.numeroPA.required"
                >*</small
              >
              PA:
            </label>
            <div class="input-group">
              <v-select
                multiple
                ref="selectPA"
                :closeOnSelect="false"
                :clearSearchOnSelect="false"
                v-model="form.numeroPA.value"
                :options="form.numeroPA.options"
                :reduce="(x) => x.value"
                class="w-100"
                label="text"
                placeholder="Selecione o PA"
              >
                <template v-slot:no-options>{{
                  $lang.Common.PlaceholderSelect
                }}</template>
                <template #list-header>
                  <button
                    class="btn btn-secondary btn-sm btn-block"
                    @click.prevent="handleSelectAllPA"
                  >
                    Selecionar todos
                  </button>
                </template>
              </v-select>
            </div>
          </div>
          <div class="col-md-4">
            <label>
              <small
                class="text-danger"
                v-if="form.regionalId.required"
                >*</small
              >
              Regional:
            </label>
            <div class="input-group">
              <v-select
                multiple
                ref="selectRegional"
                :closeOnSelect="false"
                :clearSearchOnSelect="false"
                v-model="form.regionalId.value"
                :options="form.regionalId.options"
                :reduce="(x) => x.value"
                class="w-100"
                label="text"
                placeholder="Selecione a Regional"
              >
                <template v-slot:no-options>{{
                  $lang.Common.PlaceholderSelect
                }}</template>
                <template #list-header>
                  <button
                    class="btn btn-secondary btn-sm btn-block"
                    @click.prevent="handleSelectAllRegional"
                  >
                    Selecionar todos
                  </button>
                </template>
              </v-select>
            </div>
          </div>
          <div class="col-md-4">
            <label>
              <small
                class="text-danger"
                v-if="form.clusterizacaoId.required"
                >*</small
              >
              Clusterização:
            </label>
            <div class="input-group">
              <v-select
                multiple
                ref="selectCluster"
                :closeOnSelect="false"
                :clearSearchOnSelect="false"
                v-model="form.clusterizacaoId.value"
                :options="form.clusterizacaoId.options"
                :reduce="(x) => x.value"
                class="w-100"
                label="text"
                placeholder="Selecione o Cluster"
              >
                <template v-slot:no-options>{{
                  $lang.Common.PlaceholderSelect
                }}</template>
                <template #list-header>
                  <button
                    class="btn btn-secondary btn-sm btn-block"
                    @click.prevent="handleSelectAllCluster"
                  >
                    Selecionar todos
                  </button>
                </template>
              </v-select>
            </div>
          </div>
        </div>

        <!-- gerente | agente de relacionamento -->
        <div class="form-group row">
          <div class="col-md-4">
            <label>
              <small
                class="text-danger"
                v-if="form.gerenteId.required"
                >*</small
              >
              {{ $t('associates.gerenteSisbr') }}
            </label>
            <div class="input-group">
              <v-select
                multiple
                ref="selectGerente"
                :closeOnSelect="false"
                :clearSearchOnSelect="false"
                v-model="form.gerenteId.value"
                :options="form.gerenteId.options"
                :reduce="(x) => x.value"
                class="w-100"
                label="text"
                :placeholder="`Selecione o ${$t('associates.gerenteSisbr')}`"
              >
                <template v-slot:no-options>{{
                  $lang.Common.PlaceholderSelect
                }}</template>
                <template #list-header>
                  <button
                    class="btn btn-secondary btn-sm btn-block"
                    @click.prevent="handleSelectAllGerente"
                  >
                    Selecionar todos
                  </button>
                </template>
              </v-select>
            </div>
          </div>
          <div class="col-md-4">
            <label>
              <small
                class="text-danger"
                v-if="form.gerenteRelacionamentoId.required"
                >*</small
              >
              Agente de Relacionamento:
            </label>
            <div class="input-group">
              <v-select
                multiple
                ref="selectGerenteRelacionamento"
                :closeOnSelect="false"
                :clearSearchOnSelect="false"
                v-model="form.gerenteRelacionamentoId.value"
                :options="form.gerenteRelacionamentoId.options"
                :reduce="(x) => x.value"
                class="w-100"
                label="text"
                placeholder="Selecione o Agente de Relacionamento"
              >
                <template v-slot:no-options>{{
                  $lang.Common.PlaceholderSelect
                }}</template>
                <template #list-header>
                  <button
                    class="btn btn-secondary btn-sm btn-block"
                    @click.prevent="handleSelectAllGerenteRelacionamento"
                  >
                    Selecionar todos
                  </button>
                </template>
              </v-select>
            </div>
          </div>
          <div class="col-md-4 mt-4">
            <span
              :class="['btn btn-default btn-outline-dark rounded pointer']"
              style="width: 100%; margin-bottom: 0"
              @click="toggleAdvancedSearch()"
            >
              <i :class="advancedSearch ? 'fas fa-minus' : 'fas fa-plus'"></i>
            </span>
          </div>
        </div>

        <div
          id="BuscaAvancada"
          v-if="advancedSearch"
        >
          <hr />
          <div class="form-group row">
            <div class="col-md-3">
              <label
                style="
                  font-size: medium;
                  font-weight: 600;
                  letter-spacing: 0.3px;
                  color: #2e6e60;
                  cursor: pointer;
                "
                @click.prevent="
                  showFilterAssociado === true
                    ? (showFilterAssociado = false)
                    : (showFilterAssociado = true)
                "
              >
                <i
                  v-if="showFilterAssociado"
                  class="fas fa-caret-down"
                ></i>
                <i
                  v-else
                  class="fas fa-caret-right"
                ></i>
                Associado</label
              >
              <i
                v-if="hasAssociadoFilter"
                class="fas fa-check pl-2"
                style="color: #2e6e60"
              ></i>
            </div>
          </div>
          <div v-if="showFilterAssociado">
            <!-- faixa de data de nascimento | faixa de inicio de relacionamento -->
            <div class="form-group row pt-2">
              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-md-3">
                    <label> Data de Nascimento/Abertura Inicial: </label>
                    <NxDatePicker
                      :placeholder="$lang.Common.DatePlaceholder"
                      v-model="form.dataInicioNascimentoOuAbertura.value"
                      :required="form.dataInicioNascimentoOuAbertura.required"
                      :state="form.dataInicioNascimentoOuAbertura.state"
                    />
                  </div>
                  <div class="col-md-3">
                    <label> Data de Nascimento/Abertura Final: </label>
                    <NxDatePicker
                      :placeholder="$lang.Common.DatePlaceholder"
                      v-model="form.dataFinalNascimentoOuAbertura.value"
                      :required="form.dataFinalNascimentoOuAbertura.required"
                      :state="form.dataFinalNascimentoOuAbertura.state"
                    />
                  </div>

                  <div class="col-md-3">
                    <label> Faixa de Relacionamento Inicial: </label>
                    <NxDatePicker
                      :placeholder="$lang.Common.DatePlaceholder"
                      v-model="form.dataInicialInicioRelacionamento.value"
                      :required="form.dataInicialInicioRelacionamento.required"
                      :state="form.dataInicialInicioRelacionamento.state"
                    />
                  </div>

                  <div class="col-md-3">
                    <label> Faixa de Relacionamento Final: </label>
                    <NxDatePicker
                      :placeholder="$lang.Common.DatePlaceholder"
                      v-model="form.dataFinalInicioRelacionamento.value"
                      :required="form.dataFinalInicioRelacionamento.required"
                      :state="form.dataFinalInicioRelacionamento.state"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group row pt-2">
                  <div class="col-md-3">
                    <label> Dia de Nascimento: </label>
                    <v-select v-model="form.diaAniversarioAssociado.value" :options="form.diaAniversarioAssociado.options" multiple></v-select>
                  </div>
                  <div class="col-md-3">
                    <label> Mês de Nascimento: </label>
                    <v-select v-model="form.mesAniversarioAssociado.value" :options="form.mesAniversarioAssociado.options" multiple></v-select>
                  </div>
                </div>
              </div>
            </div>
            <!-- faixa de data de Ult Renovacao -->
            <div class="form-group row pt-2">
              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-md-3">
                    <label> Faixa de Última Renovação Inicial: </label>
                    <NxDatePicker
                      :placeholder="$lang.Common.DatePlaceholder"
                      v-model="form.dataInicialUltimaRenovacao.value"
                      :required="form.dataInicialUltimaRenovacao.required"
                      :state="form.dataInicialUltimaRenovacao.state"
                    />
                  </div>
                  <div class="col-md-3">
                    <label> Faixa de Última Renovação Final: </label>
                    <NxDatePicker
                      :placeholder="$lang.Common.DatePlaceholder"
                      v-model="form.dataFinalUltimaRenovacao.value"
                      :required="form.dataFinalUltimaRenovacao.required"
                      :state="form.dataFinalUltimaRenovacao.state"
                    />
                  </div>
                </div>
              </div>
            </div>

            <!-- tipo pessoa | pendencias | sexo | estado -->
            <div class="form-group row">
              <div class="col-md-3">
                <label>
                  <small
                    class="text-danger"
                    v-if="form.tipoPessoa.required"
                    >*</small
                  >
                  Tipo Pessoa:
                </label>
                <v-select
                  multiple
                  v-model="form.tipoPessoa.value"
                  :options="form.tipoPessoa.options"
                  :reduce="(x) => x.value"
                  class="w-100"
                  label="text"
                  placeholder="Selecione o Tipo de Pessoa"
                >
                  <template v-slot:no-options>{{
                    $lang.Common.PlaceholderSelect
                  }}</template>
                </v-select>
              </div>
              <div class="col-md-3">
                <label>
                  <small
                    class="text-danger"
                    v-if="form.sexo.required"
                    >*</small
                  >
                  Sexo:
                </label>
                <div class="input-group">
                  <v-select
                    multiple
                    v-model="form.sexo.value"
                    :options="form.sexo.options"
                    :reduce="(x) => x.value"
                    class="w-100"
                    label="text"
                    placeholder="Selecione o sexo"
                  >
                    <template v-slot:no-options>{{
                      $lang.Common.PlaceholderSelect
                    }}</template>
                  </v-select>
                </div>
              </div>
              <div class="col-md-3">
                <label>
                  <small
                    class="text-danger"
                    v-if="form.estado.required"
                    >*</small
                  >
                  Estado:
                </label>
                <div class="input-group">
                  <v-select
                    multiple
                    ref="selectEstado"
                    :closeOnSelect="false"
                    :clearSearchOnSelect="false"
                    v-model="form.estado.value"
                    :options="form.estado.options"
                    :reduce="(x) => x.value"
                    class="w-100"
                    label="text"
                    placeholder="Selecione o estado"
                  >
                    <template v-slot:no-options>{{
                      $lang.Common.PlaceholderSelect
                    }}</template>
                    <template #list-header>
                      <button
                        class="btn btn-secondary btn-sm btn-block"
                        @click.prevent="handleSelectAllEstado"
                      >
                        Selecionar todos
                      </button>
                    </template>
                  </v-select>
                </div>
              </div>
              <div class="col-md-3">
                <label>
                  <small
                    class="text-danger"
                    v-if="form.pendencias.required"
                    >*</small
                  >
                  Possíveis Pendências:
                </label>
                <div class="input-group">
                  <v-select
                    multiple
                    ref="selectPendencias"
                    :closeOnSelect="false"
                    :clearSearchOnSelect="false"
                    v-model="form.pendencias.value"
                    :options="form.pendencias.options"
                    :reduce="(x) => x.value"
                    class="w-100"
                    label="text"
                    placeholder="Selecione a Pendência"
                  >
                    <template v-slot:no-options>{{
                      $lang.Common.PlaceholderSelect
                    }}</template>
                    <template #list-header>
                      <button
                        class="btn btn-secondary btn-sm btn-block"
                        @click.prevent="handleSelectAllPendencias"
                      >
                        Selecionar todos
                      </button>
                    </template>
                  </v-select>
                </div>
              </div>
              <div class="col-md-3" style="margin-top: 12px;">
                <label>
                  <small
                    class="text-danger"
                    v-if="form.naoPossuiPendencias.required"
                    >*</small
                  >
                  Pendências que não possui:
                </label>
                <div class="input-group">
                  <v-select
                    multiple
                    ref="selectnaoPossuiPendencias"
                    :closeOnSelect="false"
                    :clearSearchOnSelect="false"
                    v-model="form.naoPossuiPendencias.value"
                    :options="form.naoPossuiPendencias.options"
                    :reduce="(x) => x.value"
                    class="w-100"
                    label="text"
                    placeholder="Selecione a Pendência que não Possui"
                  >
                    <template v-slot:no-options>{{
                      $lang.Common.PlaceholderSelect
                    }}</template>
                    <template #list-header>
                      <button
                        class="btn btn-secondary btn-sm btn-block"
                        @click.prevent="handleSelectAllnaoPossuiPendencias"
                      >
                        Selecionar todos
                      </button>
                    </template>
                  </v-select>
                </div>
              </div>
              <div class="col-md-3" style="margin-top: 12px;">
                <label>
                  <small
                    class="text-danger"
                    v-if="form.tag.required"
                    >*</small
                  >
                  Tag:
                </label>
                <div class="input-group">
                  <v-select
                    multiple
                    ref="selectTag"
                    :closeOnSelect="false"
                    :clearSearchOnSelect="false"
                    v-model="form.tag.value"
                    :options="form.tag.options"
                    :reduce="(x) => x.value"
                    class="w-100"
                    label="text"
                    placeholder="Selecione a Tag"
                  >
                    <template v-slot:no-options>{{
                      $lang.Common.PlaceholderSelect
                    }}</template>
                    <template #list-header>
                      <button
                        class="btn btn-secondary btn-sm btn-block"
                        @click.prevent="handleSelectAllTag"
                      >
                        Selecionar todos
                      </button>
                    </template>
                  </v-select>
                </div>
              </div>
            </div>

            <!-- vinculo empregaticio | descrição da profissao | tipo de renda -->
            <div class="form-group row pt-2">
              <div class="col-md-4">
                <label>
                  <small
                    class="text-danger"
                    v-if="form.vinculoEmpregaticio.required"
                    >*</small
                  >
                  Vinculo empregatício:
                </label>
                <div class="input-group">
                  <v-select
                    multiple
                    ref="selectVinculoEmpregaticio"
                    :closeOnSelect="false"
                    :clearSearchOnSelect="false"
                    v-model="form.vinculoEmpregaticio.value"
                    :options="form.vinculoEmpregaticio.options"
                    :reduce="(x) => x.value"
                    class="w-100"
                    label="text"
                    placeholder="Selecione o vinculo empregatício"
                  >
                    <template v-slot:no-options>{{
                      $lang.Common.PlaceholderSelect
                    }}</template>
                    <template #list-header>
                      <button
                        class="btn btn-secondary btn-sm btn-block"
                        @click.prevent="handleSelectAllVinculoEmpregaticio"
                      >
                        Selecionar todos
                      </button>
                    </template>
                  </v-select>
                </div>
              </div>
              <div class="col-md-4">
                <label>
                  <small
                    class="text-danger"
                    v-if="form.descricaoProfissao.required"
                    >*</small
                  >
                  Descrição da profissão:
                </label>
                <div class="input-group">
                  <v-select
                    multiple
                    ref="selectDescricaoProfissao"
                    :closeOnSelect="false"
                    :clearSearchOnSelect="false"
                    v-model="form.descricaoProfissao.value"
                    :options="form.descricaoProfissao.options"
                    :reduce="(x) => x.value"
                    class="w-100"
                    label="text"
                    placeholder="Selecione o descrição da profissão"
                  >
                    <template v-slot:no-options>{{
                      $lang.Common.PlaceholderSelect
                    }}</template>
                    <template #list-header>
                      <button
                        class="btn btn-secondary btn-sm btn-block"
                        @click.prevent="handleSelectAllDescricaoProfissao"
                      >
                        Selecionar todos
                      </button>
                    </template>
                  </v-select>
                </div>
              </div>
              <div class="col-md-4">
                <label>
                  <small
                    class="text-danger"
                    v-if="form.isFuncionario.required"
                    >*</small
                  >
                  É Funcionário?
                </label>
                <div class="input-group">
                  <v-select
                    multiple
                    v-model="form.isFuncionario.value"
                    :options="form.isFuncionario.options"
                    :reduce="(x) => x.value"
                    class="w-100"
                    label="text"
                    placeholder="Selecione se é funcionário"
                  >
                    <template v-slot:no-options>{{
                      $lang.Common.PlaceholderSelect
                    }}</template>
                  </v-select>
                </div>
              </div>
            </div>

            <!-- Tipo de Renda |Faixa de Renda | MEI | produtor rural  -->
            <div class="form-group row pt-2">
              <div class="col-md-4">
                <label>
                  <small
                    class="text-danger"
                    v-if="form.tipoRenda.required"
                    >*</small
                  >
                  Tipo de Renda:
                </label>
                <div class="input-group">
                  <v-select
                    multiple
                    ref="selectTipoRenda"
                    :closeOnSelect="false"
                    :clearSearchOnSelect="false"
                    v-model="form.tipoRenda.value"
                    :options="form.tipoRenda.options"
                    :reduce="(x) => x.value"
                    class="w-100"
                    label="text"
                    placeholder="Selecione o tipo de renda"
                  >
                    <template v-slot:no-options>{{
                      $lang.Common.PlaceholderSelect
                    }}</template>
                    <template #list-header>
                      <button
                        class="btn btn-secondary btn-sm btn-block"
                        @click.prevent="handleSelectAllTipoRenda"
                      >
                        Selecionar todos
                      </button>
                    </template>
                  </v-select>
                </div>
              </div>
              <div class="col-md-4">
                <label> Faixa de Renda:</label>
                <div class="input-group">
                  <money
                    :placeholder="$lang.Currency.Placeholder"
                    class="form-control text-bold"
                    max-length="12"
                    v-model.lazy="rendaInicial"
                    v-bind="$lang.Currency.Format"
                  ></money>
                  <money
                    :placeholder="$lang.Currency.Placeholder"
                    class="form-control text-bold"
                    max-length="12"
                    v-model.lazy="rendaFinal"
                    v-bind="$lang.Currency.Format"
                  ></money>
                </div>
              </div>
              <div class="col-md-2">
                <label>
                  <small
                    class="text-danger"
                    v-if="form.mei.required"
                    >*</small
                  >
                  É MEI:
                </label>
                <div>
                  <b-form-group>
                    <b-form-radio-group
                      v-model="form.mei.value"
                      aria-describedby="mei"
                      :required="form.mei.required"
                    >
                      <b-form-radio value="true">Sim</b-form-radio>
                      <b-form-radio value="false">Não</b-form-radio>
                    </b-form-radio-group>
                  </b-form-group>
                </div>
              </div>
              <div class="col-md-2">
                <label>
                  <small
                    class="text-danger"
                    v-if="form.produtorRural.required"
                    >*</small
                  >
                  É Produtor Rural:
                </label>
                <div>
                  <b-form-group>
                    <b-form-radio-group
                      v-model="form.produtorRural.value"
                      aria-describedby="produtorRural"
                      :required="form.produtorRural.required"
                    >
                      <b-form-radio value="true">Sim</b-form-radio>
                      <b-form-radio value="false">Não</b-form-radio>
                    </b-form-radio-group>
                  </b-form-group>
                </div>
              </div>
            </div>
            <hr />
          </div>

          <div class="form-group row">
            <div class="col-md-3">
              <label
                style="
                  font-size: medium;
                  font-weight: 600;
                  letter-spacing: 0.3px;
                  color: #2e6e60;
                  cursor: pointer;
                "
                @click.prevent="
                  showFilterProduto === true
                    ? (showFilterProduto = false)
                    : (showFilterProduto = true)
                "
              >
                <i
                  v-if="showFilterProduto"
                  class="fas fa-caret-down"
                ></i>
                <i
                  v-else
                  class="fas fa-caret-right"
                ></i>
                Produto</label
              >
              <i
                v-if="hasProdutoFilter"
                class="fas fa-check pl-2"
                style="color: #2e6e60"
              ></i>
            </div>
          </div>
          <div v-if="showFilterProduto">
            <!-- conta corrente | conta capital | IAP que possui -->
            <div class="form-group row pt-2">
              <div class="col-md-4">
                <label>
                  <small
                    class="text-danger"
                    v-if="form.statusContaCorrente.required"
                    >*</small
                  >
                  Status da Conta Corrente:
                </label>
                <div class="input-group">
                  <v-select
                    multiple
                    ref="selectStatusContaCorrente"
                    :closeOnSelect="false"
                    :clearSearchOnSelect="false"
                    v-model="form.statusContaCorrente.value"
                    :options="form.statusContaCorrente.options"
                    :reduce="(x) => x.value"
                    class="w-100"
                    label="text"
                    placeholder="Selecione o Status da Conta Corrente"
                  >
                    <template v-slot:no-options>{{
                      $lang.Common.PlaceholderSelect
                    }}</template>
                    <template #list-header>
                      <button
                        class="btn btn-secondary btn-sm btn-block"
                        @click.prevent="handleSelectAllContaCorrente"
                      >
                        Selecionar todos
                      </button>
                    </template>
                  </v-select>
                </div>
              </div>
              <div class="col-md-4">
                <label>
                  <small
                    class="text-danger"
                    v-if="form.statusMatricula.required"
                    >*</small
                  >
                  Status da Conta Capital:
                </label>
                <div class="input-group">
                  <v-select
                    multiple
                    :closeOnSelect="false"
                    v-model="form.statusMatricula.value"
                    :options="form.statusMatricula.options"
                    :reduce="(x) => x.value"
                    class="w-100"
                    label="text"
                    placeholder="Selecione o Status da Conta Capital"
                  >
                    <template v-slot:no-options>{{
                      $lang.Common.PlaceholderSelect
                    }}</template>
                  </v-select>
                </div>
              </div>
              <div class="col-md-4">
                <label>
                  <small
                    class="text-danger"
                    v-if="form.utilizacaoProdutosPossui.required"
                    >*</small
                  >
                  Produtos IAP que possui:
                </label>
                <div class="input-group">
                  <v-select
                    multiple
                    ref="selectIap"
                    :closeOnSelect="false"
                    :clearSearchOnSelect="false"
                    v-model="form.utilizacaoProdutosPossui.value"
                    :options="form.utilizacaoProdutosPossui.options"
                    :reduce="(x) => x.value"
                    class="w-100"
                    label="text"
                    placeholder="Selecione os produtos IAP que possui"
                  >
                    <template v-slot:no-options>{{
                      $lang.Common.PlaceholderSelect
                    }}</template>
                    <template #list-header>
                      <button
                        class="btn btn-secondary btn-sm btn-block"
                        @click.prevent="handleSelectAllIap"
                      >
                        Selecionar todos
                      </button>
                    </template>
                  </v-select>
                </div>
              </div>
            </div>
            <!-- IAP que não possui | Vigencia Apolice Seguro-->
            <div class="form-group row pt-2">
              <div class="col-md-4">
                <label>
                  <small
                    class="text-danger"
                    v-if="form.utilizacaoProdutosNaoPossui.required"
                    >*</small
                  >
                  Produtos IAP que não possui:
                </label>
                <div class="input-group">
                  <v-select
                    multiple
                    ref="selectutilizacaoProdutosNaoPossui"
                    :closeOnSelect="false"
                    :clearSearchOnSelect="false"
                    v-model="form.utilizacaoProdutosNaoPossui.value"
                    :options="form.utilizacaoProdutosNaoPossui.options"
                    :reduce="(x) => x.value"
                    class="w-100"
                    label="text"
                    placeholder="Selecione os produtos IAP que não possui"
                  >
                    <template v-slot:no-options>{{
                      $lang.Common.PlaceholderSelect
                    }}</template>
                    <template #list-header>
                      <button
                        class="btn btn-secondary btn-sm btn-block"
                        @click.prevent="handleSelectAllutilizacaoProdutosNaoPossui"
                      >
                        Selecionar todos
                      </button>
                    </template>
                  </v-select>
                </div>
              </div>
              <div class="col-md-3">
                <label> Data Vigência Apólice Inicial: </label>
                <NxDatePicker
                  :placeholder="$lang.Common.DatePlaceholder"
                  v-model="form.dataInicialApoliceSeguro.value"
                  :required="form.dataInicialApoliceSeguro.required"
                  :state="form.dataInicialApoliceSeguro.state"
                />
              </div>
              <div class="col-md-3">
                <label> Data Vigência Apólice Final: </label>
                <NxDatePicker
                  :placeholder="$lang.Common.DatePlaceholder"
                  v-model="form.dataFinalApoliceSeguro.value"
                  :required="form.dataFinalApoliceSeguro.required"
                  :state="form.dataFinalApoliceSeguro.state"
                />
              </div>
            </div>
            <hr />
          </div>

          <div class="form-group row">
            <div class="col-md-3">
              <label
                style="
                  font-size: medium;
                  font-weight: 600;
                  letter-spacing: 0.3px;
                  color: #2e6e60;
                  cursor: pointer;
                "
                @click.prevent="
                  showFilterCredito === true
                    ? (showFilterCredito = false)
                    : (showFilterCredito = true)
                "
              >
                <i
                  v-if="showFilterCredito"
                  class="fas fa-caret-down"
                ></i>
                <i
                  v-else
                  class="fas fa-caret-right"
                ></i>
                Crédito</label
              >
              <i
                v-if="hasCreditoFilter"
                class="fas fa-check pl-2"
                style="color: #2e6e60"
              ></i>
            </div>
          </div>
          <div v-if="showFilterCredito">
            <!-- margem contribuição | período margem contribuição -->
            <div class="form-group row">
              <div class="col-md-4">
                <div>
                  <label> Valor Margem de Contribuição Bruta:</label>
                  <div class="input-group">
                    <money
                      placeholder="$lang.Currency.Placeholder"
                      class="form-control text-bold"
                      max-length="12"
                      v-model.lazy="margemContribuicaoInicial"
                      v-bind="$lang.Currency.Format"
                    ></money>
                    <money
                      placeholder="$lang.Currency.Placeholder"
                      class="form-control text-bold"
                      max-length="12"
                      v-model.lazy="margemContribuicaoFinal"
                      v-bind="$lang.Currency.Format"
                    ></money>
                  </div>
                </div>
              </div>

              <div class="col-md-3">
                <label> Período Margem Contribuição Inicial: </label>
                <NxDatePicker
                  :placeholder="$lang.Common.DatePlaceholder"
                  v-model="form.dataInicialMargemContribuicao.value"
                  :required="form.dataInicialMargemContribuicao.required"
                  :state="form.dataInicialMargemContribuicao.state"
                />
              </div>
              <div class="col-md-3">
                <label> Período Margem Contribuição Final: </label>
                <NxDatePicker
                  :placeholder="$lang.Common.DatePlaceholder"
                  v-model="form.dataFinalMargemContribuicao.value"
                  :required="form.dataFinalMargemContribuicao.required"
                  :state="form.dataFinalMargemContribuicao.state"
                />
              </div>
            </div>
            <!-- risco CRL -->
            <div class="form-group row">
              <div class="col-md-4">
                <div>
                  <label> Nível Limite Risco CRL:</label>
                  <div class="input-group">
                    <v-select
                      multiple
                      ref="selectRiscoLimiteCRL"
                      :closeOnSelect="false"
                      :clearSearchOnSelect="false"
                      v-model="form.riscoLimiteCRL.value"
                      :options="form.riscoLimiteCRL.options"
                      :reduce="(x) => x.value"
                      class="w-100"
                      label="text"
                      placeholder="Selecione o Nível do Risco CRL"
                    >
                      <template #list-header>
                        <button
                          class="btn btn-secondary btn-sm btn-block"
                          @click.prevent="handleSelectAllRiscoLimiteCRL"
                        >
                          Selecionar todos
                        </button>
                      </template>
                    </v-select>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div>
                  <label> Modalidade Produto:</label>
                  <div class="input-group">
                    <v-select
                      multiple
                      ref="selectModalidadeProduto"
                      :closeOnSelect="false"
                      :clearSearchOnSelect="false"
                      v-model="form.modalidadeProduto.value"
                      :options="form.modalidadeProduto.options"
                      :reduce="(x) => x.value"
                      class="w-100"
                      label="text"
                      placeholder="Selecione a Modalidade Produto"
                    >
                      <template #list-header>
                        <button
                          class="btn btn-secondary btn-sm btn-block"
                          @click.prevent="handleSelectAllModalidadeProduto"
                        >
                          Selecionar todos
                        </button>
                      </template>
                    </v-select>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div>
                  <label> Submodalidade Bacen:</label>
                  <div class="input-group">
                    <v-select
                      multiple
                      ref="selectSubmodalidadeBacen"
                      :closeOnSelect="false"
                      :clearSearchOnSelect="false"
                      v-model="form.submodalidadeBacen.value"
                      :options="form.submodalidadeBacen.options"
                      :reduce="(x) => x.value"
                      class="w-100"
                      label="text"
                      placeholder="Selecione a Submodalidade Bacen"
                    >
                      <template #list-header>
                        <button
                          class="btn btn-secondary btn-sm btn-block"
                          @click.prevent="handleSelectAllSubmodalidadeBacen"
                        >
                          Selecionar todos
                        </button>
                      </template>
                    </v-select>
                  </div>
                </div>
              </div>
            </div>
            <!-- data vencimento contrato | data vigencia apolice seguro -->
            <div class="form-group row pt-2">
              <div class="col-md-3">
                <label> Data Vencimento Op. de crédito Inicial: </label>
                <NxDatePicker
                  :placeholder="$lang.Common.DatePlaceholder"
                  v-model="form.dataInicialVencimentoContrato.value"
                  :required="form.dataInicialVencimentoContrato.required"
                  :state="form.dataInicialVencimentoContrato.state"
                />
              </div>
              <div class="col-md-3">
                <label> Data Vencimento Op. de crédito Final: </label>
                <NxDatePicker
                  :placeholder="$lang.Common.DatePlaceholder"
                  v-model="form.dataFinalVencimentoContrato.value"
                  :required="form.dataFinalVencimentoContrato.required"
                  :state="form.dataFinalVencimentoContrato.state"
                />
              </div>

              <div class="col-md-3">
                <label> Data Vencimento Pagamento Parcela Inicial: </label>
                <NxDatePicker
                  :placeholder="$lang.Common.DatePlaceholder"
                  v-model="form.dataInicialVencimentoPagamentoParcela.value"
                  :required="
                    form.dataInicialVencimentoPagamentoParcela.required
                  "
                  :state="form.dataInicialVencimentoPagamentoParcela.state"
                />
              </div>
              <div class="col-md-3">
                <label> Data Vencimento Pagamento Parcela Final: </label>
                <NxDatePicker
                  :placeholder="$lang.Common.DatePlaceholder"
                  v-model="form.dataFinalVencimentoPagamentoParcela.value"
                  :required="form.dataFinalVencimentoPagamentoParcela.required"
                  :state="form.dataFinalVencimentoPagamentoParcela.state"
                />
              </div>
            </div>

            <div class="form-group row pt-2">
              <NxInputNumberRange
                label="Dias em atraso:"
                @update:InitialValue="
                  handleInputUpdate('diasAtrasoInicio', $event)
                "
                @update:FinalValue="
                  handleInputUpdate('diasAtrasoFinal', $event)
                "
              />
            </div>
          </div>

          <div class="form-group row">
            <div class="col-md-3">
              <label
                style="
                  font-size: medium;
                  font-weight: 600;
                  letter-spacing: 0.3px;
                  color: #2e6e60;
                  cursor: pointer;
                "
                @click.prevent="
                  showFilterMovimentacaoConta === true
                    ? (showFilterMovimentacaoConta = false)
                    : (showFilterMovimentacaoConta = true)
                "
              >
                <i
                  v-if="showFilterMovimentacaoConta"
                  class="fas fa-caret-down"
                ></i>
                <i
                  v-else
                  class="fas fa-caret-right"
                ></i>
                Movimentação da Conta</label
              >
              <i
                v-if="hasMovimentacaoContaFilter"
                class="fas fa-check pl-2"
                style="color: #2e6e60"
              ></i>
            </div>
          </div>
          <div v-if="showFilterMovimentacaoConta">
            <!-- classificação de Lançamento | periodo classificação de Lançamento -->
            <div class="form-group row">
              <div class="col-md-4">
                <label>
                  <small
                    class="text-danger"
                    v-if="form.classificacaoLancamentoMovimentacao.required"
                    >*</small
                  >
                  Classificação de Lançamento:
                </label>
                <div class="input-group">
                  <v-select
                    multiple
                    ref="selectClassificacaoLancamentoMovimentacao"
                    :closeOnSelect="false"
                    :clearSearchOnSelect="false"
                    v-model="form.classificacaoLancamentoMovimentacao.value"
                    :options="form.classificacaoLancamentoMovimentacao.options"
                    :reduce="(x) => x.value"
                    class="w-100"
                    label="text"
                    placeholder="Selecione a classificação de lançamento"
                  >
                    <template v-slot:no-options>
                      {{ $lang.Common.PlaceholderSelect }}
                    </template>
                    <template #list-header>
                      <button
                        class="btn btn-secondary btn-sm btn-block"
                        @click.prevent="
                          handleSelectAllClassificacaoLancamentoMovimentacao
                        "
                      >
                        Selecionar todos
                      </button>
                    </template>
                  </v-select>
                </div>
              </div>

              <div class="col-md-3">
                <label> Período Lançamento Inicial: </label>
                <NxDatePicker
                  :placeholder="$lang.Common.DatePlaceholder"
                  v-model="form.dataInicialMovimentacaoDiaria.value"
                  :required="form.dataInicialMovimentacaoDiaria.required"
                  :state="form.dataInicialMovimentacaoDiaria.state"
                />
              </div>
              <div class="col-md-3">
                <label> Período Lançamento Final: </label>
                <NxDatePicker
                  :placeholder="$lang.Common.DatePlaceholder"
                  v-model="form.dataFinalMovimentacaoDiaria.value"
                  :required="form.dataFinalMovimentacaoDiaria.required"
                  :state="form.dataFinalMovimentacaoDiaria.state"
                />
              </div>
            </div>
            <!-- Valor de Lançamento -->
            <div class="form-group row">
              <div class="col-md-4">
                <div>
                  <label> Valor de lançamento:</label>
                  <div class="input-group">
                    <money
                      placeholder="$lang.Currency.Placeholder"
                      class="form-control text-bold"
                      max-length="12"
                      v-model.lazy="valorLancamentoInicial"
                      v-bind="$lang.Currency.Format"
                    ></money>
                    <money
                      placeholder="$lang.Currency.Placeholder"
                      class="form-control text-bold"
                      max-length="12"
                      v-model.lazy="valorLancamentoFinal"
                      v-bind="$lang.Currency.Format"
                    ></money>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="form-group row">
            <div class="col-md-3">
              <label
                style="
                  font-size: medium;
                  font-weight: 600;
                  letter-spacing: 0.3px;
                  color: #2e6e60;
                  cursor: pointer;
                "
                @click.prevent="
                  showFilterCartaoCredito === true
                    ? (showFilterCartaoCredito = false)
                    : (showFilterCartaoCredito = true)
                "
              >
                <i
                  v-if="showFilterCartaoCredito"
                  class="fas fa-caret-down"
                ></i>
                <i
                  v-else
                  class="fas fa-caret-right"
                ></i>
                Cartão de Crédito</label
              >
              <i
                v-if="hasCartaoCreditoFilter"
                class="fas fa-check pl-2"
                style="color: #2e6e60"
              ></i>
            </div>
          </div>
          <div v-if="showFilterCartaoCredito">
            <!-- Limite Atribuido cartao credito | Limite Disponivel cartao credito -->
            <div class="form-groups row">
              <div class="col-md-4">
                <div>
                  <label> Limite Atribuído:</label>
                  <div class="input-group">
                    <money
                      placeholder="$lang.Currency.Placeholder"
                      class="form-control text-bold"
                      max-length="12"
                      v-model.lazy="limiteAtribuidoInicial"
                      v-bind="$lang.Currency.Format"
                    ></money>
                    <money
                      placeholder="$lang.Currency.Placeholder"
                      class="form-control text-bold"
                      max-length="12"
                      v-model.lazy="limiteAtribuidoFinal"
                      v-bind="$lang.Currency.Format"
                    ></money>
                  </div>
                </div>
              </div>

              <div class="col-md-4">
                <div>
                  <label> Limite Disponível:</label>
                  <div class="input-group">
                    <money
                      placeholder="$lang.Currency.Placeholder"
                      class="form-control text-bold"
                      max-length="12"
                      v-model.lazy="limiteDisponivelInicial"
                      v-bind="$lang.Currency.Format"
                    ></money>
                    <money
                      placeholder="$lang.Currency.Placeholder"
                      class="form-control text-bold"
                      max-length="12"
                      v-model.lazy="limiteDisponivelFinal"
                      v-bind="$lang.Currency.Format"
                    ></money>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="form-group row">
            <div class="col-md-3">
              <label
                style="
                  font-size: medium;
                  font-weight: 600;
                  letter-spacing: 0.3px;
                  color: #2e6e60;
                  cursor: pointer;
                "
                @click.prevent="
                  showFilterInvestimentos === true
                    ? (showFilterInvestimentos = false)
                    : (showFilterInvestimentos = true)
                "
              >
                <i
                  v-if="showFilterInvestimentos"
                  class="fas fa-caret-down"
                ></i>
                <i
                  v-else
                  class="fas fa-caret-right"
                ></i>
                Investimentos</label
              >
              <i
                v-if="hasInvestimentosFilter"
                class="fas fa-check pl-2"
                style="color: #2e6e60"
              ></i>
            </div>
          </div>
          <div v-if="showFilterInvestimentos">
            <div class="form-group row">
              <div class="col-md-4">
                <label>
                  <small
                    class="text-danger"
                    v-if="form.modalidadeCaptacao.required"
                    >*</small
                  >
                  Modalidade Captação:
                </label>
                <div class="input-group">
                  <v-select
                    multiple
                    ref="selectModalidadeCaptacao"
                    :closeOnSelect="false"
                    :clearSearchOnSelect="false"
                    v-model="form.modalidadeCaptacao.value"
                    :options="form.modalidadeCaptacao.options"
                    :reduce="(x) => x.value"
                    class="w-100"
                    label="text"
                    placeholder="Selecione a modalidade de Captacao"
                  >
                    <template v-slot:no-options>
                      {{ $lang.Common.PlaceholderSelect }}
                    </template>
                    <template #list-header>
                      <button
                        class="btn btn-secondary btn-sm btn-block"
                        @click.prevent="handleSelectAllModalidadeAplicacao"
                      >
                        Selecionar todos
                      </button>
                    </template>
                  </v-select>
                </div>
              </div>

              <div class="col-md-4">
                <div>
                  <label> Faixa Saldo Diario:</label>
                  <div class="input-group">
                    <money
                      placeholder="$lang.Currency.Placeholder"
                      class="form-control text-bold"
                      max-length="12"
                      v-model.lazy="valorSaldoDiarioInicial"
                      v-bind="$lang.Currency.Format"
                    ></money>
                    <money
                      placeholder="$lang.Currency.Placeholder"
                      class="form-control text-bold"
                      max-length="12"
                      v-model.lazy="valorSaldoDiarioFinal"
                      v-bind="$lang.Currency.Format"
                    ></money>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group row">
              <div class="col-md-3">
                <label> Data Vencimento Aplicação Inicial:</label>
                <NxDatePicker
                  :placeholder="$lang.Common.DatePlaceholder"
                  v-model="form.dataInicialVencimentoAplicacao.value"
                  :required="form.dataInicialVencimentoAplicacao.required"
                  :state="form.dataInicialVencimentoAplicacao.state"
                />
              </div>
              <div class="col-md-3">
                <label> Data Vencimento Aplicação Final:</label>
                <NxDatePicker
                  :placeholder="$lang.Common.DatePlaceholder"
                  v-model="form.dataFinalVencimentoAplicacao.value"
                  :required="form.dataFinalVencimentoAplicacao.required"
                  :state="form.dataFinalVencimentoAplicacao.state"
                />
              </div>

              <div class="col-md-3">
                <label> Data Aplicação Inicial: </label>
                <NxDatePicker
                  :placeholder="$lang.Common.DatePlaceholder"
                  v-model="form.dataInicialAplicacao.value"
                  :required="form.dataInicialAplicacao.required"
                  :state="form.dataInicialAplicacao.state"
                />
              </div>
              <div class="col-md-3">
                <label> Data Aplicação Final: </label>
                <NxDatePicker
                  :placeholder="$lang.Common.DatePlaceholder"
                  v-model="form.dataFinalAplicacao.value"
                  :required="form.dataFinalAplicacao.required"
                  :state="form.dataFinalAplicacao.state"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="form-group row pt-3 pb-3">
          <div class="col-md-12">
            <button
              type="button"
              class="btn btn-third btn-sm"
              v-b-tooltip.hover
              :title="'Pesquisar'"
              @click.prevent="onSearchButton"
              :disabled="isButtonDisabled()"
            >
              <i class="fas fa-search"></i>
              <span class="d-md-down-none"> Pesquisar</span>
            </button>
            <button
              type="button"
              class="btn btn-default btn-sm text-secundary"
              v-on:click="onClear"
              v-b-tooltip.hover
              :title="$lang.Common.Tooltip.ButtonClear"
            >
              <i class="fa fa-minus-circle"></i>
              <span class="d-md-down-none">
                {{ $lang.Common.Buttons.Clear }}</span
              >
            </button>
          </div>
        </div>

        <FilterKpi ref="FilterKpi" />

        <Tables
          ref="tableGridAdv"
          :columns="[
            $t('associates.abreviacaoNumber'),
            'CPF/CNPJ',
            'Nome',
            'E-mail',
            'Celular'
          ]"
          :showTipFooter="false"
          :showHeader="true"
          v-on:Load="onSearch"
        >
          <tr
            v-for="(obj, index) in this.objList"
            v-bind:key="index"
          >
            <TableColumn
              :IsText="true"
              :status="1"
              :value="obj.numId.toString()"
            />
            <TableColumn
              :IsText="true"
              :status="1"
              :value="obj.document"
            />
            <TableColumn
              :IsText="true"
              :status="1"
              :value="obj.name ? obj.name.toUpperCase() : ''"
            />
            <TableColumn
              :IsText="true"
              :status="1"
              :value="obj.email"
            />
            <TableColumn
              :IsText="true"
              :status="1"
              :value="obj.telefone"
            />
          </tr>
        </Tables>
      </div>
      <template #modal-footer>
        <div class="w-100 text-right">
          <button
            type="button"
            class="btn btn-third btn-sm"
            v-b-tooltip.hover
            :title="'Adicionar'"
            @click="onCreate"
          >
            <i class="fas fa-check-circle"></i>
            <span class="d-md-down-none"> Adicionar</span>
          </button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import Tools from '@/components/tools/Tools.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'

import PRODUCTS from '@/enums/iapProducts.js'
import AssociateRepository from '@/shared/http/repositories/business/associate.js'
import DailyAccountMovementRepository from '@/shared/http/repositories/business/dailyaccountmovement.js'
import ClusterRepository from '@/shared/http/repositories/configurations/cluster.js'
import EmployeeRepository from '@/shared/http/repositories/configurations/employee.js'
import ListaContatoRepository from '@/shared/http/repositories/configurations/listacontato.js'
import ListaInteligenteRepository from '@/shared/http/repositories/configurations/listainteligente'
import PARepository from '@/shared/http/repositories/configurations/pa.js'
import RegionalRepository from '@/shared/http/repositories/configurations/regional.js'
import TagRepository from '@/shared/http/repositories/configurations/tag.js'
import CaptacaoRemuneradaDiariaRepository from '../../shared/http/repositories/business/captacaoremuneradadiaria.js'
import ContratosVigentesRepository from '../../shared/http/repositories/business/contratosvigentes'
import RiscoRepository from '../../shared/http/repositories/business/risco.js'

import FilterKpi from '@/views/private/configurations/lista-inteligente/components/add/component/FilterKpi.vue'

import NxDatePicker from '@/components/forms/NxDatePicker.vue'
import { NxInputNumberRange } from '@/components/nexum/components/custom-inputs/index.js'

const AdvancedContactData = {
  tipoPessoa: null,
  document: null,
  numId: null,
  nomeAssociado: null,
  numeroPA: null,
  gerenteId: null,
  gerenteRelacionamentoId: null,
  clusterizacaoId: null,
  regionalId: null,
  riscoLimiteCRL: null,
  modalidadeProduto: null,
  submodalidadeBacen: null,
  pendencias: null,
  naoPossuiPendencias: null,
  tag: null,
  statusContaCorrente: null,
  statusMatricula: null,
  rendaInicial: null,
  rendaFinal: null,
  dataInicialInicioRelacionamento: null,
  dataFinalInicioRelacionamento: null,
  dataInicialUltimaRenovacao: null,
  dataFinalUltimaRenovacao: null,
  dataInicioNascimentoOuAbertura: null,
  dataFinalNascimentoOuAbertura: null,
  sexo: null,
  estado: null,
  vinculoEmpregaticio: null,
  descricaoProfissao: null,
  tipoRenda: null,
  isFuncionario: null,
  mei: null,
  produtorRural: null,
  utilizacaoProdutosPossui: null,
  utilizacaoProdutosNaoPossui: null,
  margemContribuicaoInicial: null,
  margemContribuicaoFinal: null,
  dataInicialMargemContribuicao: null,
  dataFinalMargemContribuicao: null,
  classificacaoLancamentoMovimentacao: null,
  dataInicialMovimentacaoDiaria: null,
  dataFinalMovimentacaoDiaria: null,
  valorLancamentoInicial: null,
  valorLancamentoFinal: null,
  dataInicialVencimentoContrato: null,
  dataFinalVencimentoContrato: null,
  dataInicialApoliceSeguro: null,
  dataFinalApoliceSeguro: null,
  limiteAtribuidoInicial: null,
  limiteAtribuidoFinal: null,
  limiteDisponivelInicial: null,
  limiteDisponivelFinal: null,
  hasAssociadoFilter: null,
  hasProdutoFilter: null,
  hasCreditoFilter: null,
  hasMovimentacaoContaFilter: false,
  hasCartaoCreditoFilter: false,
  diasAtrasoInicio: null,
  diasAtrasoFinal: null,
  dataInicialVencimentoPagamentoParcela: null,
  dataFinalVencimentoPagamentoParcela: null,
  hasInvestimentosFilter: false,
  modalidadeCaptacao: null,
  valorSaldoDiarioInicial: null,
  valorSaldoDiarioFinal: null,
  dataInicialVencimentoAplicacao: null,
  dataFinalVencimentoAplicacao: null,
  dataInicialAplicacao: null,
  dataFinalAplicacao: null,
  diaAniversarioAssociado: null,
  mesAniversarioAssociado: null
}

const AdvancedContactForm = {
  tipoPessoa: {
    value: null,
    options: [
      { text: 'Pessoa Física', value: 'PF' },
      { text: 'Pessoa Jurídica', value: 'PJ' }
    ],
    required: false,
    state: null
  },
  document: {
    value: '',
    maxlength: '100',
    required: false,
    state: null
  },
  numId: {
    value: '',
    maxlength: '100',
    required: false,
    state: null
  },
  nomeAssociado: {
    value: '',
    maxlength: '100',
    required: false,
    state: null
  },
  numeroPA: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  gerenteId: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  gerenteRelacionamentoId: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  clusterizacaoId: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  regionalId: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  riscoLimiteCRL: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  modalidadeProduto: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  submodalidadeBacen: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  pendencias: {
    value: null,
    options: [
      { text: 'Ajuizado', value: 'AJUIZADO' },
      { text: 'Cobrança', value: 'COBRANCA' },
      { text: 'Impeditiva Absoluta', value: 'IMPEDITIVA_ABSOLUTA' },
      { text: 'Protestado', value: 'PROTESTADO' }
    ],
    required: false,
    state: null
  },
  naoPossuiPendencias: {
    value: null,
    options: [
      { text: 'Ajuizado', value: 'AJUIZADO' },
      { text: 'Cobrança', value: 'COBRANCA' },
      { text: 'Impeditiva Absoluta', value: 'IMPEDITIVA_ABSOLUTA' },
      { text: 'Protestado', value: 'PROTESTADO' }
    ],
    required: false,
    state: null
  },
  tag: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  statusContaCorrente: {
    value: null,
    options: [
      { text: 'Ativa', value: 'ATIVA' },
      { text: 'Ativa Bloqueada', value: 'ATIVA BLOQUEADA' },
      {
        text: 'Ativa Bloqueada Judicialmente',
        value: 'ATIVA BLOQUEADA JUDICIALMENTE'
      },
      { text: 'Inativa', value: 'INATIVA' },
      { text: 'Inativa Bloqueada', value: 'INATIVA BLOQUEADA' },
      {
        text: 'Inativa Bloqueada Judicialmente',
        value: 'INATIVA BLOQUEADA JUDICIALMENTE'
      },
      { text: 'Não Informado', value: 'NAO INFORMADO' }
    ],
    required: false,
    state: null
  },
  statusMatricula: {
    value: null,
    options: [
      { text: 'Ativo', value: 'ATIVO' },
      { text: 'Demitido', value: 'DEMITIDO' },
      { text: 'Eliminado', value: 'ELIMINADO' },
      { text: 'Excluído', value: 'EXCLUÍDO' }
    ],
    required: false,
    state: null
  },
  dataInicialInicioRelacionamento: {
    value: '',
    required: false,
    state: null
  },
  dataFinalInicioRelacionamento: {
    value: '',
    required: false,
    state: null
  },
  dataInicialUltimaRenovacao: {
    value: '',
    required: false,
    state: null
  },
  dataFinalUltimaRenovacao: {
    value: '',
    required: false,
    state: null
  },
  dataInicioNascimentoOuAbertura: {
    value: '',
    required: false,
    state: null
  },
  dataFinalNascimentoOuAbertura: {
    value: '',
    required: false,
    state: null
  },
  sexo: {
    value: null,
    options: [
      { text: 'Feminino', value: 'F' },
      { text: 'Masculino', value: 'M' }
    ],
    required: false,
    state: null
  },
  estado: {
    value: null,
    options: [
      { value: 'AC', text: 'Acre' },
      { value: 'AL', text: 'Alagoas' },
      { value: 'AP', text: 'Amapá' },
      { value: 'AM', text: 'Amazonas' },
      { value: 'BA', text: 'Bahia' },
      { value: 'CE', text: 'Ceará' },
      { value: 'DF', text: 'Distrito Federal' },
      { value: 'ES', text: 'Espírito Santo' },
      { value: 'GO', text: 'Goiás' },
      { value: 'MA', text: 'Maranhão' },
      { value: 'MT', text: 'Mato Grosso' },
      { value: 'MS', text: 'Mato Grosso do Sul' },
      { value: 'MG', text: 'Minas Gerais' },
      { value: 'PA', text: 'Pará' },
      { value: 'PB', text: 'Paraíba' },
      { value: 'PR', text: 'Paraná' },
      { value: 'PE', text: 'Pernambuco' },
      { value: 'PI', text: 'Piauí' },
      { value: 'RJ', text: 'Rio de Janeiro' },
      { value: 'RN', text: 'Rio Grande do Norte' },
      { value: 'RS', text: 'Rio Grande do Sul' },
      { value: 'RO', text: 'Rondônia' },
      { value: 'RR', text: 'Roraima' },
      { value: 'SC', text: 'Santa Catarina' },
      { value: 'SP', text: 'São Paulo' },
      { value: 'SE', text: 'Sergipe' },
      { value: 'TO', text: 'Tocantins' }
    ],
    required: false,
    state: null
  },
  vinculoEmpregaticio: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  descricaoProfissao: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  tipoRenda: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  isFuncionario: {
    value: null,
    options: [
      { text: 'SIM', value: 'FUNCIONARIO' },
      { text: 'NÃO', value: 'NAO_FUNCIONARIO' }
    ],
    required: false,
    state: null
  },
  mei: {
    value: null,
    required: false,
    state: null
  },
  produtorRural: {
    value: null,
    required: false,
    state: null
  },
  utilizacaoProdutosPossui: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  utilizacaoProdutosNaoPossui: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  dataInicialMargemContribuicao: {
    value: '',
    required: false,
    state: null
  },
  dataFinalMargemContribuicao: {
    value: '',
    required: false,
    state: null
  },
  classificacaoLancamentoMovimentacao: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  dataInicialMovimentacaoDiaria: {
    value: '',
    required: false,
    state: null
  },
  dataFinalMovimentacaoDiaria: {
    value: '',
    required: false,
    state: null
  },
  dataInicialVencimentoContrato: {
    value: '',
    required: false,
    state: null
  },
  dataFinalVencimentoContrato: {
    value: '',
    required: false,
    state: null
  },
  dataInicialApoliceSeguro: {
    value: '',
    required: false,
    state: null
  },
  dataFinalApoliceSeguro: {
    value: '',
    required: false,
    state: null
  },
  diasAtrasoInicio: {
    value: null,
    required: false,
    state: null
  },
  diasAtrasoFinal: {
    value: null,
    required: false,
    state: null
  },
  dataInicialVencimentoPagamentoParcela: {
    value: '',
    required: false,
    state: null
  },
  dataFinalVencimentoPagamentoParcela: {
    value: '',
    required: false,
    state: null
  },
  modalidadeCaptacao: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  dataInicialVencimentoAplicacao: {
    value: '',
    required: false,
    state: null
  },
  dataFinalVencimentoAplicacao: {
    value: '',
    required: false,
    state: null
  },
  dataInicialAplicacao: {
    value: '',
    required: false,
    state: null
  },
  dataFinalAplicacao: {
    value: '',
    required: false,
    state: null
  },
  diaAniversarioAssociado: {
    value: [],
    required: false,
    state: null,
    options: Array.from({ length: 31 }, (_, i) => i + 1).map((x) => ({
      value: x,
      label: x
    }))
  },
  mesAniversarioAssociado: {
    value: [],
    required: false,
    state: null,
    options: Array.from({ length: 12 }, (_, i) => i + 1).map((x) => ({
      value: x,
      label: x
    }))
  }
}

export default {
  name: 'ModalListaContatoAdvancedSearch',
  mixins: [ActionsForm],
  data () {
    return {
      data: AdvancedContactData,
      form: AdvancedContactForm,
      rendaInicial: 0,
      rendaFinal: 0,
      listaInteligenteId: null,
      filters: null,
      selected: [],
      selectAll: false,
      persons: [],
      advancedSearch: false,
      margemContribuicaoInicial: 0,
      margemContribuicaoFinal: 0,
      valorLancamentoInicial: 0,
      valorLancamentoFinal: 0,
      limiteAtribuidoInicial: 0,
      limiteAtribuidoFinal: 0,
      limiteDisponivelInicial: 0,
      limiteDisponivelFinal: 0,
      valorSaldoDiarioInicial: 0,
      valorSaldoDiarioFinal: 0,
      showFilterAssociado: false,
      showFilterProduto: false,
      showFilterCredito: false,
      showFilterMovimentacaoConta: false,
      showFilterCartaoCredito: false,
      showFilterOperacoesCredito: false,
      showFilterInvestimentos: false,
      hasAssociadoFilter: false,
      hasProdutoFilter: false,
      progressInterval: null,
      hasCreditoFilter: false,
      hasMovimentacaoContaFilter: false,
      hasCartaoCreditoFilter: false,
      hasInvestimentosFilter: false,
      totalCooperadosAtingidos: 0
    }
  },
  components: {
    NxDatePicker,
    FilterKpi,
    NxInputNumberRange
  },
  methods: {
    onLoad () {
      this.onClear()
    },
    onLoadAllEmployees () {
      EmployeeRepository.GetAll()
        .then((response) => {
          const funcionariosOptionList = response.data.content
            .filter((x) => x.usuarioId != null && x.pessoa != null)
            .map((x) => ({
              value: x.id,
              text: (x.pessoa && x.pessoa.nome) ? x.pessoa.nome : `Funcionário #${x.id || 'N/A'}`
            }))

          this.form.gerenteId.options = funcionariosOptionList
          this.form.gerenteRelacionamentoId.options = funcionariosOptionList
        })
        .catch((err) => this.onException(err))
    },
    onLoadAllPAs () {
      PARepository.GetAll()
        .then((response) => {
          this.form.numeroPA.options = response.data.content.map((x) => ({
            value: x.numero,
            text: x.descricao
          }))
        })
        .catch((err) => this.onException(err))
    },
    onLoadAllCluster () {
      ClusterRepository.GetAll()
        .then((response) => {
          this.form.clusterizacaoId.options = response.data.content.map(
            (x) => ({ value: x.id, text: x.descricao })
          )
        })
        .catch((err) => this.onException(err))
    },
    onLoadAllRegional () {
      RegionalRepository.GetAll()
        .then((response) => {
          this.form.regionalId.options = response.data.content.map((x) => ({
            value: x.id,
            text: x.nome
          }))
        })
        .catch((err) => this.onException(err))
    },
    onLoadAllTags () {
      TagRepository.GetAll()
        .then((response) => {
          this.form.tag.options = response.data.content.map((x) => ({
            value: x.id,
            text: x.nome
          }))
        })
        .catch((err) => this.onException(err))
    },
    onLoadAllRiscoCRL () {
      RiscoRepository.GetNivelRiscoCRL()
        .then((response) => {
          this.form.riscoLimiteCRL.options = response.data.map((x) => ({
            value: x,
            text: x
          }))
        })
        .catch((err) => this.onException(err))
    },
    onLoadAllModalidadeProduto () {
      ContratosVigentesRepository.GetModalidadeProduto()
        .then((response) => {
          this.form.modalidadeProduto.options = response.data.map((x) => ({
            value: x,
            text: x
          }))
        })
        .catch((err) => this.onException(err))
    },
    onLoadAllSubmodalidadeBacen () {
      ContratosVigentesRepository.GetSubmodalidadeBacen()
        .then((response) => {
          this.form.submodalidadeBacen.options = response.data.map((x) => ({
            value: x,
            text: x
          }))
        })
        .catch((err) => this.onException(err))
    },
    onLoadAllTipoRenda () {
      AssociateRepository.GetAllTipoRenda()
        .then((response) => {
          this.form.tipoRenda.options = response.data.map((x) => ({
            value: x,
            text: x
          }))
        })
        .catch((err) => this.onException(err))
    },
    onLoadAllDescricaoProfissao () {
      AssociateRepository.GetAllDescricaoProfissao()
        .then((response) => {
          this.form.descricaoProfissao.options = response.data.map((x) => ({
            value: x,
            text: x
          }))
        })
        .catch((err) => this.onException(err))
    },
    onLoadAllVinculoEmpregaticio () {
      AssociateRepository.GetAllVinculoEmpregaticio()
        .then((response) => {
          this.form.vinculoEmpregaticio.options = response.data.map((x) => ({
            value: x,
            text: x
          }))
        })
        .catch((err) => this.onException(err))
    },
    onLoadAllClassificacaoLancamento () {
      DailyAccountMovementRepository.GetAllClassificacaoLancamento()
        .then((response) => {
          this.form.classificacaoLancamentoMovimentacao.options =
            response.data.map((x) => ({ value: x, text: x }))
        })
        .catch((err) => this.onException(err))
    },
    onLoadAllProductsIap () {
      let productsIap = []
      let count = 0
      for (const key in PRODUCTS) {
        productsIap[count] = { text: PRODUCTS[key], value: key }
        count++
      }

      this.form.utilizacaoProdutosPossui.options = productsIap
      this.form.utilizacaoProdutosNaoPossui.options = productsIap
    },
    onLoadAllModalidadeCaptacao () {
      CaptacaoRemuneradaDiariaRepository.GetModalidadeCaptacao()
        .then((response) => {
          this.form.modalidadeCaptacao.options = response.data.map((x) => ({
            value: x,
            text: x
          }))
        })
        .catch((err) => this.onException(err))
    },
    onClear () {
      // Limpa apenas os filtros, mantém o ID da lista
      this.limparFiltros()
    },
    showModal (listaInteligenteId) {
      // Seta o ID da lista (pode ser null para lista nova)
      this.listaInteligenteId = listaInteligenteId

      // Limpa apenas os filtros, mantém o ID
      this.limparFiltros()

      // Limpa o KPI também
      if (this.$refs.FilterKpi) {
        this.$refs.FilterKpi.clearData()
      }

      this.$refs['modal-advanced-contact'].show()

      this.$nextTick(() => {
        this.onLoadAllEmployees()
        this.onLoadAllPAs()
        this.onLoadAllCluster()
        this.onLoadAllRegional()
        this.onLoadAllTipoRenda()
        this.onLoadAllRiscoCRL()
        this.onLoadAllModalidadeProduto()
        this.onLoadAllSubmodalidadeBacen()
        this.onLoadAllTags()
        this.onLoadAllDescricaoProfissao()
        this.onLoadAllVinculoEmpregaticio()
        this.onLoadAllClassificacaoLancamento()
        this.onLoadAllProductsIap()
        this.onLoadAllModalidadeCaptacao()

        // Só carrega filtros salvos se a lista tiver ID (lista existente)
        if (this.listaInteligenteId) {
          loading.push()
          ListaInteligenteRepository.FindListaInteligenteFilter(
            this.listaInteligenteId
          )
            .then((response) => {
              if (response.status === 200) {
                Tools.SetValueInForm(this.form, this.data, response.data)
                this.hasAssociadoFilter = this.data.hasAssociadoFilter
                this.hasProdutoFilter = this.data.hasProdutoFilter
                this.hasCreditoFilter = this.data.hasCreditoFilter
                this.hasMovimentacaoContaFilter =
                this.data.hasMovimentacaoContaFilter
                this.hasCartaoCreditoFilter = this.data.hasCartaoCreditoFilter
                this.hasInvestimentosFilter = this.data.hasInvestimentosFilter

                if (
                  this.data.hasAssociadoFilter ||
                this.data.hasProdutoFilter ||
                this.data.hasCreditoFilter ||
                this.data.hasMovimentacaoContaFilter ||
                this.data.hasCartaoCreditoFilter ||
                this.data.hasInvestimentosFilter
                ) {
                  this.advancedSearch = true
                }
              }
              loading.pop()
            })
            .catch(this.onException)
        }
      })
    },
    hideModal () {
      this.limparFiltros()
      this.$refs['modal-advanced-contact'].hide()
      this.$emit('created')
    },
    limparFiltros () {
      // Limpa apenas os filtros, MANTÉM o listaInteligenteId
      Tools.ClearDataForms(this.form, this.data)
      this.persons = []
      this.selected = []
      this.selectAll = false
      this.objList = []

      this.rendaInicial = 0
      this.rendaFinal = 0
      this.margemContribuicaoInicial = 0
      this.margemContribuicaoFinal = 0
      this.limiteAtribuidoInicial = 0
      this.limiteAtribuidoFinal = 0
      this.limiteDisponivelInicial = 0
      this.limiteDisponivelFinal = 0
      this.valorSaldoDiarioInicial = 0
      this.valorSaldoDiarioFinal = 0
      this.showFilterAssociado = false
      this.showFilterProduto = false
      this.showFilterCredito = false
      this.showFilterMovimentacaoConta = false
      this.showFilterCartaoCredito = false
      this.showFilterOperacoesCredito = false
      this.showFilterInvestimentos = false
      this.advancedSearch = false

      if (this.$refs.FilterKpi) {
        this.$refs.FilterKpi.clearData()
      }
    },
    onReset () {
      // Limpa TUDO, incluindo o ID (usado quando realmente precisa resetar)
      this.limparFiltros()
      this.listaInteligenteId = null

      if (this.$refs.tableGridAdv) {
        this.$refs.tableGridAdv.Clear()
      }
    },
    onSearchButton () {
      // CORREÇÃO: Método chamado pelo BOTÃO de pesquisar
      // Reseta a paginação para página 1 antes de fazer uma NOVA pesquisa
      if (this.$refs.tableGridAdv) {
        this.$refs.tableGridAdv.pagingIndex = 0
        this.$refs.tableGridAdv.currentPage = 1
      }
      // Chama o método principal de pesquisa
      this.onSearch()
    },
    onSearch () {
      if (Tools.ValidateForms(this.form, this.data, self, toast)) {
        loading.push()

        // CORREÇÃO: Limpa o total ANTES da pesquisa para evitar mostrar valores antigos
        if (this.$refs.tableGridAdv) {
          this.$refs.tableGridAdv.total = 0
          this.$refs.tableGridAdv.totalPages = 0
        }

        // CRÍTICO: Normaliza TODOS os filtros ANTES de qualquer operação
        // Garante que pesquisa, paginação e adicionar usem EXATAMENTE os mesmos filtros
        this.normalizarTodosFiltros()

        // Codifica as datas na query string (as barras / precisam ser codificadas)
        const dataEncoded = { ...this.data }
        if (dataEncoded.dataInicialInicioRelacionamento) {
          dataEncoded.dataInicialInicioRelacionamento = encodeURIComponent(dataEncoded.dataInicialInicioRelacionamento)
        }
        if (dataEncoded.dataFinalInicioRelacionamento) {
          dataEncoded.dataFinalInicioRelacionamento = encodeURIComponent(dataEncoded.dataFinalInicioRelacionamento)
        }
        if (dataEncoded.dataInicioNascimentoOuAbertura) {
          dataEncoded.dataInicioNascimentoOuAbertura = encodeURIComponent(dataEncoded.dataInicioNascimentoOuAbertura)
        }
        if (dataEncoded.dataFinalNascimentoOuAbertura) {
          dataEncoded.dataFinalNascimentoOuAbertura = encodeURIComponent(dataEncoded.dataFinalNascimentoOuAbertura)
        }
        if (dataEncoded.dataInicialUltimaRenovacao) {
          dataEncoded.dataInicialUltimaRenovacao = encodeURIComponent(dataEncoded.dataInicialUltimaRenovacao)
        }
        if (dataEncoded.dataFinalUltimaRenovacao) {
          dataEncoded.dataFinalUltimaRenovacao = encodeURIComponent(dataEncoded.dataFinalUltimaRenovacao)
        }

        let filters = Tools.getFilters(dataEncoded)

        // Usa o endpoint que retorna dados JÁ DEDUPLICADOS com paginação
        // Retorna MESMO FORMATO do endpoint original, apenas com deduplicação aplicada
        AssociateRepository.SearchCampanhaListaUnicos(
          filters,
          this.$refs.tableGridAdv.pagingLimit,
          this.$refs.tableGridAdv.pagingIndex
        )
          .then(searchResponse => {
            // Processa a pesquisa para exibir na grid (MESMO PROCESSO do endpoint original)
            const processedResponse = this.gridData(searchResponse)

            // Chama onResultGrid EXATAMENTE como as outras telas que funcionam
            this.onResultGrid(processedResponse, this.$refs.tableGridAdv)

            // Atualiza o KPI com o mesmo total da paginação (ambos deduplicados)
            const totalContatosUnicos = searchResponse.data.totalElements
            if (this.$refs.FilterKpi) {
              this.$refs.FilterKpi.loadCooperadosAtingidos(totalContatosUnicos)
            }
            this.totalCooperadosAtingidos = totalContatosUnicos
          })
          .catch(this.onException)
      }
    },
    /**
     * Normaliza TODOS os filtros do form para this.data
     * Garante que pesquisa, paginação e adicionar usem EXATAMENTE os mesmos filtros
     * Deve ser chamada ANTES de qualquer operação (pesquisa, paginação, adicionar)
     */
    normalizarTodosFiltros () {
      // Limpa valores antigos primeiro para evitar valores não normalizados
      this.data.dataInicialInicioRelacionamento = null
      this.data.dataFinalInicioRelacionamento = null
      this.data.dataInicioNascimentoOuAbertura = null
      this.data.dataFinalNascimentoOuAbertura = null
      this.data.dataInicialUltimaRenovacao = null
      this.data.dataFinalUltimaRenovacao = null

      // Normaliza e copia campos de data do form para this.data
      if (this.form.dataInicialInicioRelacionamento && this.form.dataInicialInicioRelacionamento.value) {
        this.data.dataInicialInicioRelacionamento = this.normalizarDataParaEnvio(this.form.dataInicialInicioRelacionamento.value)
      }
      if (this.form.dataFinalInicioRelacionamento && this.form.dataFinalInicioRelacionamento.value) {
        this.data.dataFinalInicioRelacionamento = this.normalizarDataParaEnvio(this.form.dataFinalInicioRelacionamento.value)
      }
      if (this.form.dataInicioNascimentoOuAbertura && this.form.dataInicioNascimentoOuAbertura.value) {
        this.data.dataInicioNascimentoOuAbertura = this.normalizarDataParaEnvio(this.form.dataInicioNascimentoOuAbertura.value)
      }
      if (this.form.dataFinalNascimentoOuAbertura && this.form.dataFinalNascimentoOuAbertura.value) {
        this.data.dataFinalNascimentoOuAbertura = this.normalizarDataParaEnvio(this.form.dataFinalNascimentoOuAbertura.value)
      }
      if (this.form.dataInicialUltimaRenovacao && this.form.dataInicialUltimaRenovacao.value) {
        this.data.dataInicialUltimaRenovacao = this.normalizarDataParaEnvio(this.form.dataInicialUltimaRenovacao.value)
      }
      if (this.form.dataFinalUltimaRenovacao && this.form.dataFinalUltimaRenovacao.value) {
        this.data.dataFinalUltimaRenovacao = this.normalizarDataParaEnvio(this.form.dataFinalUltimaRenovacao.value)
      }

      // Copia outros campos do form para this.data (mantém consistência)
      if (this.form.document && this.form.document.value) {
        this.data.document = this.form.document.value.replaceAll('-', '').replaceAll('.', '').replaceAll('/', '')
      }
      if (this.form.numId && this.form.numId.value) {
        this.data.numId = this.form.numId.value
      }
      if (this.form.nomeAssociado && this.form.nomeAssociado.value) {
        this.data.nomeAssociado = this.form.nomeAssociado.value
      }
      if (this.form.numeroPA && this.form.numeroPA.value) {
        this.data.numeroPA = this.form.numeroPA.value
      }
      if (this.form.gerenteId && this.form.gerenteId.value) {
        this.data.gerenteId = this.form.gerenteId.value
      }
      if (this.form.gerenteRelacionamentoId && this.form.gerenteRelacionamentoId.value) {
        this.data.gerenteRelacionamentoId = this.form.gerenteRelacionamentoId.value
      }
      if (this.form.regionalId && this.form.regionalId.value) {
        this.data.regionalId = this.form.regionalId.value
      }
      if (this.form.clusterizacaoId && this.form.clusterizacaoId.value) {
        this.data.clusterizacaoId = this.form.clusterizacaoId.value
      }
      if (this.form.tipoPessoa && this.form.tipoPessoa.value) {
        this.data.tipoPessoa = this.form.tipoPessoa.value
      }
      if (this.form.sexo && this.form.sexo.value) {
        this.data.sexo = this.form.sexo.value
      }
      if (this.form.estado && this.form.estado.value) {
        this.data.estado = this.form.estado.value
      }

      // Copia valores numéricos
      if (this.rendaInicial && this.rendaInicial > 0) {
        this.data.rendaInicial = this.rendaInicial
      }
      if (this.rendaFinal && this.rendaFinal > 0) {
        this.data.rendaFinal = this.rendaFinal
      }

      // Copia arrays
      if (this.form.diaAniversarioAssociado && this.form.diaAniversarioAssociado.value && this.form.diaAniversarioAssociado.value.length > 0) {
        this.data.diaAniversarioAssociado = this.form.diaAniversarioAssociado.value.map((x) => x.value)
      }
      if (this.form.mesAniversarioAssociado && this.form.mesAniversarioAssociado.value && this.form.mesAniversarioAssociado.value.length > 0) {
        this.data.mesAniversarioAssociado = this.form.mesAniversarioAssociado.value.map((x) => x.value)
      }
      // Copia array de tags (IDs das tags selecionadas)
      if (this.form.tag && this.form.tag.value && this.form.tag.value.length > 0) {
        // Se já é array de números, usa direto; senão, mapeia para pegar os valores
        if (Array.isArray(this.form.tag.value) && this.form.tag.value.length > 0) {
          this.data.tag = this.form.tag.value.map((x) => typeof x === 'object' && x.value ? x.value : x)
        }
      } else {
        this.data.tag = null
      }
    },
    /**
     * Normaliza uma data para garantir formato consistente (sem conversão de timezone)
     * Converte para string no formato dd/MM/yyyy que o backend espera
     * IMPORTANTE: Usa métodos locais (getFullYear, getMonth, getDate) para evitar conversão de timezone
     */
    normalizarDataParaEnvio (dataValue) {
      if (!dataValue) return null

      let dateObj = null

      // Se já é string no formato dd/MM/yyyy, retorna direto
      if (typeof dataValue === 'string' && /^\d{2}\/\d{2}\/\d{4}$/.test(dataValue)) {
        return dataValue
      }

      // Se é string no formato YYYY-MM-DD, converte para dd/MM/yyyy
      if (typeof dataValue === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dataValue)) {
        const [year, month, day] = dataValue.split('-')
        return `${day}/${month}/${year}`
      }

      // Se é string ISO (com hora/timezone), extrai apenas a parte da data
      if (typeof dataValue === 'string' && /^\d{4}-\d{2}-\d{2}/.test(dataValue)) {
        const match = dataValue.match(/^(\d{4})-(\d{2})-(\d{2})/)
        if (match) {
          const [, year, month, day] = match
          return `${day}/${month}/${year}`
        }
      }

      // Se é Date object, usa getFullYear/getMonth/getDate para evitar conversão de timezone
      if (dataValue instanceof Date) {
        dateObj = dataValue
      } else {
        // Tenta converter para Date
        try {
          dateObj = new Date(dataValue)
          if (isNaN(dateObj.getTime())) {
            return dataValue // Retorna original se não conseguir converter
          }
        } catch (e) {
          console.warn('Erro ao normalizar data:', e, dataValue)
          return dataValue
        }
      }

      // Formata para dd/MM/yyyy usando métodos locais (sem conversão de timezone)
      if (dateObj) {
        const day = String(dateObj.getDate()).padStart(2, '0')
        const month = String(dateObj.getMonth() + 1).padStart(2, '0')
        const year = dateObj.getFullYear()
        return `${day}/${month}/${year}`
      }

      return dataValue
    },
    select () {
      if (!this.selectAll) {
        for (let i in this.objList) {
          this.selected.push(this.objList[i])
        }
      }
    },
    onCreate () {
      const self = this

      // Valida se a lista inteligente existe antes de adicionar contatos
      if (!this.listaInteligenteId || this.listaInteligenteId === null) {
        toast.error('⚠️ Atenção: Clique em "Gravar" primeiro para salvar a lista, depois adicione os contatos.')
        return
      }

      if (Tools.ValidateForms(this.form, this.data, self, toast)) {
        // CRÍTICO: Normaliza TODOS os filtros ANTES de adicionar
        // Garante que pesquisa, paginação e adicionar usem EXATAMENTE os mesmos filtros
        this.normalizarTodosFiltros()

        const associadoFields = [
          'dataInicioNascimentoOuAbertura',
          'dataFinalNascimentoOuAbertura',
          'dataInicialInicioRelacionamento',
          'dataFinalInicioRelacionamento',
          'dataInicialUltimaRenovacao',
          'dataFinalUltimaRenovacao',
          'tipoPessoa',
          'sexo',
          'estado',
          'pendencias',
          'naoPossuiPendencias',
          'tag',
          'vinculoEmpregaticio',
          'descricaoProfissao',
          'tipoRenda',
          'isFuncionario',
          'mei',
          'produtorRural'
        ]
        const produtoFields = [
          'statusContaCorrente',
          'statusMatricula',
          'utilizacaoProdutosPossui',
          'utilizacaoProdutosNaoPossui',
          'dataInicialApoliceSeguro',
          'dataFinalApoliceSeguro'
        ]
        const creditoFields = [
          'dataInicialMargemContribuicao',
          'dataFinalMargemContribuicao',
          'riscoLimiteCRL',
          'modalidadeProduto',
          'submodalidadeBacen',
          'dataInicialVencimentoContrato',
          'dataFinalVencimentoContrato',
          'diasAtrasoInicio',
          'diasAtrasoFinal',
          'dataInicialVencimentoPagamentoParcela',
          'dataFinalVencimentoPagamentoParcela'
        ]
        const movimentacaoContaFields = [
          'classificacaoLancamentoMovimentacao',
          'dataInicialMovimentacaoDiaria',
          'dataFinalMovimentacaoDiaria'
        ]
        const investimentosFields = [
          'modalidadeCaptacao',
          'dataInicialVencimentoAplicacao',
          'dataFinalVencimentoAplicacao',
          'dataInicialAplicacao',
          'dataFinalAplicacao'
        ]

        for (let key of associadoFields) {
          if (this.form[key].value || this.rendaInicial || this.rendaFinal) {
            if (this.form[key].value && this.form[key].value.length !== 0) {
              this.hasAssociadoFilter = true
              break
            }
          } else {
            this.hasAssociadoFilter = false
          }
        }
        for (let key of produtoFields) {
          if (this.form[key].value) {
            if (this.form[key].value.length !== 0) {
              this.hasProdutoFilter = true
              break
            }
          } else {
            this.hasProdutoFilter = false
          }
        }
        for (let key of creditoFields) {
          if (
            this.form[key].value ||
            this.margemContribuicaoFinal ||
            this.valorLancamentoFinal
          ) {
            if (this.form[key].value.length !== 0) {
              this.hasCreditoFilter = true
              break
            }
          } else {
            this.hasCreditoFilter = false
          }
        }
        for (let key of movimentacaoContaFields) {
          if (
            this.form[key].value ||
            this.margemContribuicaoInicial ||
            this.valorLancamentoInicial
          ) {
            if (this.form[key].value.length !== 0) {
              this.hasMovimentacaoContaFilter = true
              break
            }
          } else {
            this.hasMovimentacaoContaFilter = false
          }
        }
        for (let key of investimentosFields) {
          if (
            this.form[key].value ||
            this.valorSaldoDiarioInicial ||
            this.valorSaldoDiarioFinal
          ) {
            if (this.form[key].value.length !== 0) {
              this.hasInvestimentosFilter = true
              break
            }
          } else {
            this.hasInvestimentosFilter = false
          }
        }

        this.hasCartaoCreditoFilter = !!(
          this.limiteAtribuidoInicial ||
          this.limiteAtribuidoFinal ||
          this.limiteDisponivelInicial ||
          this.limiteDisponivelFinal
        )

        this.data.hasAssociadoFilter = this.hasAssociadoFilter
        this.data.hasProdutoFilter = this.hasProdutoFilter
        this.data.hasCreditoFilter = this.hasCreditoFilter
        this.data.hasMovimentacaoContaFilter = this.hasMovimentacaoContaFilter
        this.data.hasCartaoCreditoFilter = this.hasCartaoCreditoFilter
        this.data.hasInvestimentosFilter = this.hasInvestimentosFilter

        if (this.form.diaAniversarioAssociado.value && this.form.diaAniversarioAssociado.value.length > 0) {
          this.data.diaAniversarioAssociado = this.form.diaAniversarioAssociado.value.map((x) => x.value)
        }

        if (this.form.mesAniversarioAssociado.value && this.form.mesAniversarioAssociado.value.length > 0) {
          this.data.mesAniversarioAssociado = this.form.mesAniversarioAssociado.value.map((x) => x.value)
        }

        if (this.form.gerenteId && this.form.gerenteId.value) {
          this.data.gerenteId = this.form.gerenteId.value
        }
        if (this.form.gerenteRelacionamentoId && this.form.gerenteRelacionamentoId.value) {
          this.data.gerenteRelacionamentoId = this.form.gerenteRelacionamentoId.value
        }
        if (this.form.nomeAssociado && this.form.nomeAssociado.value) {
          this.data.nomeAssociado = this.form.nomeAssociado.value
        }
        if (this.form.document && this.form.document.value) {
          this.data.document = this.form.document.value
        }
        if (this.form.numId && this.form.numId.value) {
          this.data.numId = this.form.numId.value
        }
        if (this.form.numeroPA && this.form.numeroPA.value) {
          this.data.numeroPA = this.form.numeroPA.value
        }
        if (this.form.regionalId && this.form.regionalId.value) {
          this.data.regionalId = this.form.regionalId.value
        }
        // A normalização de todos os filtros (incluindo datas) já foi feita acima
        // através da chamada this.normalizarTodosFiltros()

        // Mostra modal com barra de progresso
        this.mostrarProgressoImportacao()

        ListaContatoRepository.ImportWithFilterListaInteligente(
          this.listaInteligenteId,
          this.data
        )
          .then((response) => {
            if (response.status === 201 || response.status === 200) {
              // Completa a barra de progresso
              this.completarProgresso()

              setTimeout(() => {
                this.fecharProgresso()

                // Mensagem de sucesso com informações
                const totalAdicionados = (this.$refs.FilterKpi && this.$refs.FilterKpi.totalCooperadosAtingidos)
                  ? this.$refs.FilterKpi.totalCooperadosAtingidos
                  : (this.persons.length || 'Vários')
                toast.success(`✅ ${totalAdicionados} contatos adicionados e salvos automaticamente!`, {
                  duration: 5000
                })

                // Fecha o modal primeiro
                this.hideModal()

                // Aguarda um pouco para o modal fechar e então recarrega
                setTimeout(() => {
                  // Emite evento para recarregar os grids de contatos
                  this.$emit('created')
                }, 300)
              }, 800)
            }
          })
          .catch((error) => {
            this.fecharProgresso()

            // Mensagem de erro mais específica
            let mensagemErro = 'Erro ao adicionar contatos. '
            if (error.response && error.response.status === 400) {
              mensagemErro += 'Verifique os filtros selecionados.'
            } else if (error.response && error.response.status === 500) {
              mensagemErro += 'Erro no servidor. Tente novamente.'
            } else {
              mensagemErro += 'Verifique sua conexão ou tente novamente.'
            }

            toast.error(mensagemErro)
          })
      }
    },
    mostrarProgressoImportacao () {
      const modalAnterior = document.getElementById('modal-progresso-importacao')
      if (modalAnterior) {
        modalAnterior.remove()
      }

      const backdrops = document.querySelectorAll('.modal-backdrop')
      backdrops.forEach(backdrop => backdrop.remove())

      const backdrop = document.createElement('div')
      backdrop.className = 'modal-backdrop fade show'
      backdrop.style.cssText = 'z-index: 1060;'
      document.body.appendChild(backdrop)

      const progressoHtml = `
        <div id="modal-progresso-importacao" class="modal fade show" style="display: block; z-index: 1070;" tabindex="-1" role="dialog">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header text-white" style="background-color: #04a791;">
                <h5 class="modal-title">
                  <i class="fas fa-sync-alt fa-spin mr-2"></i>
                  Adicionando Contatos
                </h5>
              </div>
              <div class="modal-body">
                <div class="progress mb-3" style="height: 30px;">
                  <div id="progress-bar-importacao" 
                       class="progress-bar progress-bar-striped progress-bar-animated" 
                       role="progressbar" 
                       style="width: 0%; background-color: #04a791;">
                    <span id="progress-text" style="color: white; font-weight: bold;">0%</span>
                  </div>
                </div>
                <div class="text-center">
                  <p id="progress-message" class="mb-2"><strong>Iniciando importação...</strong></p>
                  <small class="text-muted" id="progress-detail">Preparando processamento em lotes</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      `

      document.body.insertAdjacentHTML('beforeend', progressoHtml)
      this.iniciarAnimacaoProgresso()
    },
    iniciarAnimacaoProgresso () {
      let percentual = 0
      const totalCooperados = this.totalCooperadosAtingidos || 1000
      const lotesEstimados = Math.max(Math.ceil(totalCooperados / 1500), 1)

      // Estima tempo de processamento baseado no volume (aproximadamente 0.015s por contato)
      const tempoEstimadoSegundos = Math.max(totalCooperados * 0.015, 10)

      // Calcula velocidade para chegar em 85% no tempo estimado
      // 85% dividido pelo número de atualizações (tempoEstimado / 0.5s)
      const numeroAtualizacoes = tempoEstimadoSegundos / 0.5
      const velocidadeBase = 85 / numeroAtualizacoes

      const mensagens = [
        { pct: 5, msg: 'Iniciando processo...', detail: 'Preparando ambiente' },
        { pct: 15, msg: 'Buscando associados...', detail: `Aplicando filtros - ${totalCooperados} registros encontrados` },
        { pct: 30, msg: `Processando lote 1 de ${lotesEstimados}`, detail: 'Expandindo telefones e removendo duplicados' },
        { pct: 50, msg: `Processando lote ${Math.ceil(lotesEstimados / 2)} de ${lotesEstimados}`, detail: 'Validando e-mails e telefones' },
        { pct: 70, msg: `Processando lote ${lotesEstimados} de ${lotesEstimados}`, detail: 'Salvando contatos no banco de dados' },
        { pct: 85, msg: 'Finalizando...', detail: 'Concluindo processamento' }
      ]

      let indiceMensagem = 0

      this.progressInterval = setInterval(() => {
        if (percentual < 85) {
          // Velocidade adaptativa baseada no volume de dados
          const velocidade = percentual < 30 ? velocidadeBase * 1.3 : (percentual < 60 ? velocidadeBase * 1.1 : (percentual < 75 ? velocidadeBase * 0.9 : velocidadeBase * 0.7))
          percentual += velocidade
          if (percentual > 85) percentual = 85

          if (indiceMensagem < mensagens.length && percentual >= mensagens[indiceMensagem].pct) {
            const msgElement = document.getElementById('progress-message')
            const detailElement = document.getElementById('progress-detail')

            if (msgElement) {
              msgElement.innerHTML = `<strong>${mensagens[indiceMensagem].msg}</strong>`
            }
            if (detailElement) {
              detailElement.textContent = mensagens[indiceMensagem].detail
            }
            indiceMensagem++
          }
        }

        const progressBar = document.getElementById('progress-bar-importacao')
        const progressText = document.getElementById('progress-text')
        if (progressBar && progressText) {
          progressBar.style.width = percentual + '%'
          progressText.textContent = Math.floor(percentual) + '%'
        }
      }, 500)
    },
    completarProgresso () {
      if (this.progressInterval) {
        clearInterval(this.progressInterval)
      }

      const progressBar = document.getElementById('progress-bar-importacao')
      const progressText = document.getElementById('progress-text')
      const progressMessage = document.getElementById('progress-message')
      const progressDetail = document.getElementById('progress-detail')

      if (progressBar) progressBar.style.width = '100%'
      if (progressText) progressText.textContent = '100%'
      if (progressMessage) progressMessage.innerHTML = '<strong>Contatos adicionados com sucesso!</strong>'
      if (progressDetail) progressDetail.textContent = 'Processo concluído.'
      if (progressDetail) progressDetail.textContent = 'Todos os contatos foram salvos na lista'
    },
    fecharProgresso () {
      if (this.progressInterval) {
        clearInterval(this.progressInterval)
        this.progressInterval = null
      }

      const modal = document.getElementById('modal-progresso-importacao')
      if (modal) {
        modal.classList.remove('show')
        modal.style.display = 'none'
        setTimeout(() => modal.remove(), 300)
      }

      const backdrops = document.querySelectorAll('.modal-backdrop')
      backdrops.forEach(backdrop => {
        backdrop.classList.remove('show')
        setTimeout(() => backdrop.remove(), 300)
      })
    },
    gridData (response) {
      // CORREÇÃO: Backend JÁ retorna dados deduplicados e paginados corretamente
      // NÃO devemos expandir registros no frontend (causava 10 virar 11/12)
      if (
        response.data &&
        response.data.content &&
        response.data.content.length > 0
      ) {
        // Apenas formata os dados para exibição, SEM expandir registros (sem flatMap)
        response.data.content = response.data.content.map((item) => {
          const pessoa = item.pessoa || {}
          const telefones = pessoa.telefone || []

          // Pega o primeiro celular (backend já deduplicou por telefone)
          const celular = telefones.find(
            (contato) => contato.tipoContato === 'CELULAR'
          )

          return {
            numId: item.numId || '',
            document: pessoa.document || '',
            name: pessoa.nome || '',
            email: pessoa.email || '',
            telefone: celular ? celular.telefone : ''
          }
        })
      } else {
        response.data.content = []
      }

      return response
    },
    toggleAdvancedSearch () {
      this.advancedSearch = !this.advancedSearch
    },
    isButtonDisabled () {
      const formFields = [
        'nomeAssociado',
        'document',
        'numId',
        'numeroPA',
        'regionalId',
        'clusterizacaoId',
        'gerenteId',
        'gerenteRelacionamentoId',
        'dataInicioNascimentoOuAbertura',
        'dataFinalNascimentoOuAbertura',
        'dataInicialInicioRelacionamento',
        'dataFinalInicioRelacionamento',
        'dataInicialUltimaRenovacao',
        'dataFinalUltimaRenovacao',
        'tipoPessoa',
        'sexo',
        'estado',
        'pendencias',
        'naoPossuiPendencias',
        'tag',
        'vinculoEmpregaticio',
        'descricaoProfissao',
        'tipoRenda',
        'isFuncionario',
        'mei',
        'produtorRural',
        'statusContaCorrente',
        'statusMatricula',
        'utilizacaoProdutosPossui',
        'utilizacaoProdutosNaoPossui',
        'dataInicialApoliceSeguro',
        'dataFinalApoliceSeguro',
        'dataInicialMargemContribuicao',
        'dataFinalMargemContribuicao',
        'riscoLimiteCRL',
        'modalidadeProduto',
        'submodalidadeBacen',
        'classificacaoLancamentoMovimentacao',
        'dataInicialMovimentacaoDiaria',
        'dataFinalMovimentacaoDiaria',
        'dataInicialVencimentoContrato',
        'dataFinalVencimentoContrato',
        'diasAtrasoInicio',
        'diasAtrasoFinal',
        'dataInicialVencimentoPagamentoParcela',
        'dataFinalVencimentoPagamentoParcela',
        'modalidadeCaptacao',
        'dataInicialVencimentoAplicacao',
        'dataFinalVencimentoAplicacao',
        'dataInicialAplicacao',
        'dataFinalAplicacao',
        'diaAniversarioAssociado',
        'mesAniversarioAssociado'
      ]

      return !formFields.some((field) => {
        const value = this.form[field].value
        // Para arrays (como tag, pendencias, etc), verifica se tem elementos
        if (Array.isArray(value)) {
          return value.length > 0
        }
        // Para valores simples, verifica se não é null, undefined ou string vazia
        return value !== null && value !== undefined && value !== ''
      })
    },
    handleSelectAll (fieldName, refName) {
      const select = this.$refs[refName]
      const visibleOptions = select.filteredOptions.map(
        (option) => option.value
      )
      this.form[fieldName].value = visibleOptions
    },
    handleSelectAllPA () {
      this.handleSelectAll('numeroPA', 'selectPA')
    },
    handleSelectAllRegional () {
      this.handleSelectAll('regionalId', 'selectRegional')
    },
    handleSelectAllCluster () {
      this.handleSelectAll('clusterizacaoId', 'selectCluster')
    },
    handleSelectAllGerente () {
      this.handleSelectAll('gerenteId', 'selectGerente')
    },
    handleSelectAllGerenteRelacionamento () {
      this.handleSelectAll(
        'gerenteRelacionamentoId',
        'selectGerenteRelacionamento'
      )
    },
    handleSelectAllEstado () {
      this.handleSelectAll('estado', 'selectEstado')
    },
    handleSelectAllPendencias () {
      this.handleSelectAll('pendencias', 'selectPendencias')
    },
    handleSelectAllnaoPossuiPendencias () {
      this.handleSelectAll('naoPossuiPendencias', 'selectnaoPossuiPendencias')
    },
    handleSelectAllTag () {
      this.handleSelectAll('tag', 'selectTag')
    },
    handleSelectAllVinculoEmpregaticio () {
      this.handleSelectAll('vinculoEmpregaticio', 'selectVinculoEmpregaticio')
    },
    handleSelectAllDescricaoProfissao () {
      this.handleSelectAll('descricaoProfissao', 'selectDescricaoProfissao')
    },
    handleSelectAllTipoRenda () {
      this.handleSelectAll('tipoRenda', 'selectTipoRenda')
    },
    handleSelectAllContaCorrente () {
      this.handleSelectAll('statusContaCorrente', 'selectStatusContaCorrente')
    },
    handleSelectAllRiscoLimiteCRL () {
      this.handleSelectAll('riscoLimiteCRL', 'selectRiscoLimiteCRL')
    },
    handleSelectAllIap () {
      this.handleSelectAll('utilizacaoProdutosPossui', 'selectIap')
    },
    handleSelectAllutilizacaoProdutosNaoPossui () {
      this.handleSelectAll('utilizacaoProdutosNaoPossui', 'selectutilizacaoProdutosNaoPossui')
    },
    handleSelectAllClassificacaoLancamentoMovimentacao () {
      this.handleSelectAll(
        'classificacaoLancamentoMovimentacao',
        'selectClassificacaoLancamentoMovimentacao'
      )
    },
    handleSelectAllModalidadeProduto () {
      this.handleSelectAll('modalidadeProduto', 'selectModalidadeProduto')
    },
    handleSelectAllSubmodalidadeBacen () {
      this.handleSelectAll('submodalidadeBacen', 'selectSubmodalidadeBacen')
    },
    handleSelectAllModalidadeAplicacao () {
      this.handleSelectAll('modalidadeCaptacao', 'selectModalidadeCaptacao')
    },
    handleInputUpdate (fieldName, inputedValue, clean = true) {
      if (inputedValue) {
        this.form[fieldName].value = clean
          ? inputedValue.replace(/[^a-zA-Z0-9 ]/g, '')
          : inputedValue
      } else {
        this.clearField(fieldName)
      }
    },
    clearField (field) {
      this.form[field].value = null
    }
  },
  beforeDestroy () {
    // Limpa intervalo de progresso se existir
    if (this.progressInterval) {
      clearInterval(this.progressInterval)
    }
    // Remove modal de progresso se existir
    this.fecharProgresso()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/ModalListaContatoAdvancedSearch.vue